const REQUEST_COURSE_RUN_OPTIONS_FAIL = 'REQUEST_COURSE_RUN_OPTIONS_FAIL';
const REQUEST_COURSE_RUN_OPTIONS_SUCCESS = 'REQUEST_COURSE_RUN_OPTIONS_SUCCESS';
const REQUEST_COURSE_RUN_OPTIONS = 'REQUEST_COURSE_RUN_OPTIONS';

export {
  REQUEST_COURSE_RUN_OPTIONS_FAIL,
  REQUEST_COURSE_RUN_OPTIONS_SUCCESS,
  REQUEST_COURSE_RUN_OPTIONS,
};
